export default __webpack_public_path__ + "static/media/mail-send.5df7a349.svg";